import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EMPTY, from } from 'rxjs';
import { filter, mapTo } from 'rxjs/operators';
import { ApBaseClass, createEventEmitterFromSource, EventComposite, LoginRedirectType } from 'webcommon/shared';
import { ApUrlMarker, LoginInitializationService, LoginResult, LoginStatus } from 'webcommon/provider-api';
import { LogOffService } from 'webcommon/legacy-common';

// todo: convert these to required inputs, instead of putting them in selector
@Component({
  selector: 'ap-login-redirect-handler[urlMarker][redirectType]',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './login-redirect-handler.component.html',
  styleUrls: ['./login-redirect-handler.component.less']
})
export class LoginRedirectHandlerComponent extends ApBaseClass implements OnInit {
  @Input() urlMarker: ApUrlMarker;
  @Input() redirectType: LoginRedirectType;

  readonly LoginStatus = LoginStatus;

  private loginInitializationService = inject(LoginInitializationService);
  private readonly loginUrlFromRedirect = this.loginInitializationService.getLoginUrlFromRedirect({});
  private logOffService = inject(LogOffService);
  loginFromRedirect = new EventComposite(this, (config: {loginToComplete?: LoginResult}) => {
    // pass in loginToComplete to complete an already started login, instead of starting over the process
    if (config.loginToComplete) {
      // try to complete the login if possible.
      // else, just return EMPTY, because it's not one that can be completed
      return config.loginToComplete.TryCompleteLogin ?
        from(config.loginToComplete.TryCompleteLogin()) :
        EMPTY;
    }

    return from(this.loginInitializationService.tryLoginFromRedirect(
      this.urlMarker,
      this.redirectType
    ));
  });
  @Output() afterLogin: EventEmitter<boolean> = createEventEmitterFromSource(this, this.loginFromRedirect.afterLoad$.pipe(
    filter(value => value.Status === LoginStatus.Completed),
    mapTo(true),
  ));

  ngOnInit(): void {
    // im not subscribing to this in async pipe (which happens during or after OnInit),
    // but I am creating a subscription with @Output() afterLogin, so start it here
    this.loginFromRedirect.start({});
  }

  onClickGoToLogin(): void {
    this.logOffService.logoffFromFailedLoginRedirect(this.loginUrlFromRedirect);
  }

  onClickCompleteLogin(loginResult: LoginResult): void {
    this.loginFromRedirect.change$.next({
      loginToComplete: loginResult,
    });
  }
}
